export default __webpack_public_path__ + "static/media/G0125.34I-29381_-17752_0.1666245540000.25a3d153.jpg";